import styled from 'styled-components/macro';

export const CropWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-height: 400px;
  overflow: hidden;
  background: ${props => props.theme.colors.neutral[10]};
`;
